import { CSSProperties } from 'react'
import { createSelector } from 'reselect'
import moment from 'moment'
import { toHslaString } from 'shared/mappers'
import { sortLeaderboard } from './functions'

export const getLeaderboardConfiguration = (state: RootState) => state.leaderboard

export const getLeaderboardInstanceSettings = createSelector(getLeaderboardConfiguration, leaderboardConfiguration => leaderboardConfiguration && leaderboardConfiguration.instanceSettings)

export const getTitleTextStyle = createSelector(getLeaderboardInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.titleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.titleColor),
    fontStyle: instanceSettings.layoutSettings.titleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.titleBold ? 'bold' : 'normal',
})

export const getSubTitleTextStyle = createSelector(getLeaderboardInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.subTitleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.subTitleColor),
    fontStyle: instanceSettings.layoutSettings.subTitleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.subTitleBold ? 'bold' : 'normal',
})

export const mapStyles = (backgroundColor: ColorHsla, color: ColorHsla, fontSize: number, fontWeight: boolean): CSSProperties => ({
    backgroundColor: toHslaString(backgroundColor),
    color: toHslaString(color),
    fontSize: `${fontSize}px`,
    fontWeight: fontWeight ? 'bold' : 'normal',
})

export const getDataGridStyleOptions = createSelector(getLeaderboardInstanceSettings, instanceSettings => instanceSettings && {
    headerStyle: mapStyles(
        instanceSettings.layoutSettings.backgroundHeaderColor,
        instanceSettings.layoutSettings.fontHeaderColor,
        instanceSettings.layoutSettings.headerFontSize,
        instanceSettings.layoutSettings.headerBold),
    evenStyle: mapStyles(
        instanceSettings.layoutSettings.backgroundEvenColor,
        instanceSettings.layoutSettings.fontEvenColor,
        instanceSettings.layoutSettings.evenFontSize,
        instanceSettings.layoutSettings.evenBold),
    oddStyle: mapStyles(
        instanceSettings.layoutSettings.backgroundOddColor,
        instanceSettings.layoutSettings.fontOddColor,
        instanceSettings.layoutSettings.oddFontSize,
        instanceSettings.layoutSettings.oddBold),
})

export const getDataGridEvenOptions = createSelector(getDataGridStyleOptions, options => options && options.evenStyle)
export const getDataGridOddOptions = createSelector(getDataGridStyleOptions, options => options && options.oddStyle)
export const getDataGridHeaderOptions = createSelector(getDataGridStyleOptions, options => options && options.headerStyle)

export const getLeaderboardDisplayEndDateTime = createSelector(getLeaderboardInstanceSettings, settings => settings && settings.displayEndDateTime && moment(settings.displayEndDateTime))

export const getLeaderboardDisplayStartDateTime = createSelector(getLeaderboardInstanceSettings, settings => settings && moment(settings.displayStartDateTime))

export const getShowModule = createSelector(getLeaderboardDisplayEndDateTime, getLeaderboardDisplayStartDateTime, (displayEndDateTime, displayStartDateTime) =>
    moment().isAfter(displayStartDateTime) && (!displayEndDateTime || moment().isBefore(displayEndDateTime)))

export const getLeaderboardSort = createSelector(getLeaderboardConfiguration, leaderboardState => leaderboardState && leaderboardState.sort)
export const getLeaderboardData = createSelector(getLeaderboardConfiguration, leaderboardState => leaderboardState && leaderboardState.data)

export const getLeaderboardDataSorted = createSelector([getLeaderboardData, getLeaderboardSort], (leaderboardData, leaderboardSort) =>
    leaderboardData && leaderboardSort && leaderboardData.sort(sortLeaderboard(leaderboardSort))
)

export const getOverrideDisplayLimit = createSelector(getLeaderboardConfiguration, leaderboardState => leaderboardState && leaderboardState.overrideDisplayLimit)
